import { Box, BoxProps } from '@chakra-ui/react'
import { useInterval } from 'react-use'
import { useSpring, animated } from 'react-spring'
import { withPrefix } from 'gatsby'
import * as React from 'react'

import { LocalizedText } from '../common/Text'
import { useResponsive } from '../../hooks/useResponsive'
import { vw } from '../../styles/theme'
import Carousel from '../carousel/Carousel'

const numImages = 6
const getImagePath = (platform: 'sp' | 'pc', index: number) => {
  return withPrefix(`/images/top_main_visual_${platform}_${index % numImages}.jpg`)
}

const AnimatedCarousel = animated(Carousel)
export type TopMainVisualProps = BoxProps & {}

const TopMainVisual: React.FC<TopMainVisualProps> = ({ ...others }) => {
  // TODO: SPの高さ
  const platform = useResponsive('sp', 'pc')
  const [index, setIndex] = React.useState(0)

  const [initialized, setInitialized] = React.useState(false)

  const initialImage = React.useMemo(() => {
    const result = new Image()
    result.onload = () => {
      setInitialized(true)
    }
    result.src = getImagePath(platform, 0)
    return result
  }, [])

  const [from, setFrom] = React.useState<string | HTMLImageElement>(initialImage)
  const [to, setTo] = React.useState(getImagePath(platform, 1))

  const [progressSpring, profressApi] = useSpring(() => ({ progress: 0 }))
  const fadeSpring = useSpring({ opacity: initialized ? 1 : 0, config: { mass: 1, tension: 280, friction: 60 } })

  const updateImage = () => {
    setFrom(getImagePath(platform, index))
    setTo(getImagePath(platform, index + 1))
  }

  useInterval(() => {
    setIndex(index + 1)
    updateImage()
    profressApi.start({
      config: { duration: 1500 },
      from: { progress: 0 },
      to: { progress: 1 },
    })
  }, 5000)

  React.useEffect(() => {
    updateImage()
  }, [platform])

  return (
    <>
      <Box
        pos="relative"
        m={['0 auto', '0 10px 0 88px']}
        w={['contentSP', 'calc(100% - 88px)']}
        h="100vh"
        display="flex"
        flexDirection="row"
        alignItems="flex-end"
        {...others}
      >
        <Box w={['100%', '78%']} h={['100%', `${(666 / 768) * 100}%`]}>
          <AnimatedCarousel
            w="100%"
            h="100%"
            from={from}
            to={to}
            progress={progressSpring.progress}
            style={fadeSpring}
          />
        </Box>
        <Box
          pos="absolute"
          bottom="0"
          right={[vw(-9), '58px']}
          textAlign={['right']}
          transform={['rotate(90deg)', 'none']}
          transformOrigin={['bottom right', 'center']}
        >
          <LocalizedText
            localizeKey={`top__main__head_1_${platform}`}
            fontSize={[vw(18), '20px']}
            lineHeight={'1.3'}
            fontFamily="headline2"
            whiteSpace="nowrap"
          />
        </Box>
      </Box>
    </>
  )
}

export default TopMainVisual
